export var valuesSymbolType = ["circle", "rect", "roundRect", "triangle", "diamond", "pin", "arrow", "none"];
//# sourceMappingURL=SymbolType.js.map